import React from 'react'
import styles from './userAvatar.module.css'
import CloseIcon from '../../common/buttons/closeButton'

interface UserAvatarProps {
  userId: string
  avatarUrl: string
  name: string
  showDeleteButton: boolean
  onDeleteClick: (userId: string) => void
}

const UserAvatar: React.FC<UserAvatarProps> = ({
  userId,
  avatarUrl,
  name,
  showDeleteButton,
  onDeleteClick
}) => {
  return (
    <div>
      <div className={styles.imageWrapper}>
        <img
          src={avatarUrl ?? '/profilepic.png'}
          alt="user avatar"
          className="avatar"
        />
        {showDeleteButton && (
          <CloseIcon
            className={styles.closeIcon}
            clickHandler={() => {
              onDeleteClick(userId)
            }}
          />
        )}
      </div>
      <div className="gray-text text-center mt-1">{name}</div>
    </div>
  )
}

export default UserAvatar
